import React from 'react';
import { ButtonTW } from '../../../tailwindComponents/buttonTW/ButtonTW';
import { useFormikContext } from 'formik';

export const SubmissionFooter: React.FC<{ onCancel: () => void; disabled?: boolean }> = ({
  onCancel,
  disabled = false,
}) => {
  const { isValid, dirty } = useFormikContext();

  return (
    <>
      <div className={'h-16'} />
      <div className={'fixed bottom-0 right-0 h-16 w-screen max-w-md border-t-2 bg-white'}>
        <div className={'flex w-full flex-row-reverse gap-4 p-4'}>
          <ButtonTW disabled={!isValid || !dirty || disabled} type={'submit'}>
            Submit
          </ButtonTW>
          <ButtonTW onClick={onCancel} secondary>
            Cancel
          </ButtonTW>
        </div>
      </div>
    </>
  );
};
